import { Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DemoRecipeDetail } from '../../../mocks/data/demoRecipeTypes';
import { applyRoundAndFormat } from '../../../utils';

const DemoTrialTab = ({ detail, currencyCode }: { detail: DemoRecipeDetail; currencyCode?: string }) => {
  const { t } = useTranslation('recipeV2');
  const criteria = detail.trialSuccessCriteria;

  if (!criteria) return <Typography color="text.secondary">{t('demoAdvanced.noTrial')}</Typography>;

  const targets = [
    [t('trial.minimumCustomerRating'), `${criteria.minimumCustomerRating}/5`],
    [t('trial.minimumSalesPer100Diners'), String(criteria.minimumSalesPer100Diners)],
    [t('trial.maximumWastePercentage'), `${criteria.maximumWastePercentage}%`],
    [t('trial.maximumFoodCostPercentage'), `${criteria.maximumFoodCostPercentage}%`],
    [t('trial.minimumGrossProfitPerPortion'), applyRoundAndFormat(criteria.minimumGrossProfitPerPortion, currencyCode)],
    [t('trial.minimumOperationalApprovalPercentage'), `${criteria.minimumOperationalApprovalPercentage}%`],
    [t('trial.unresolvedAllergenConcernsAllowed'), String(criteria.unresolvedAllergenConcernsAllowed)],
  ];

  return (
    <Stack spacing={2}>
      <Typography variant="textLG"
        fontWeight={600}>{t('trial.successCriteriaTitle')}</Typography>
      <Typography color="text.secondary">{t('demoAdvanced.trialTargets')}</Typography>
      {targets.map(([label, value]) => (
        <Paper key={label}
          variant="outlined"
          sx={{ p: 2, display: 'flex', justifyContent: 'space-between', gap: 2 }}>
          <Typography variant="textSM">{label}</Typography>
          <Typography variant="textSM"
            fontWeight={600}>{value}</Typography>
        </Paper>
      ))}
    </Stack>
  );
};

export default DemoTrialTab;
